export type RuntimeHealthFetcher = (
  input: RequestInfo | URL,
  init?: RequestInit,
) => Promise<Response>;

export async function fetchRuntimeHealth(
  fetcher: RuntimeHealthFetcher = fetch,
): Promise<boolean> {
  try {
    const response = await fetcher("/api/v1/health", { cache: "no-store" });
    return response.ok;
  } catch {
    return false;
  }
}
